import { render } from "./NotificationList.vue?vue&type=template&id=187bbbb2&ts=true"
import script from "./NotificationList.vue?vue&type=script&lang=ts"
export * from "./NotificationList.vue?vue&type=script&lang=ts"

import "./NotificationList.vue?vue&type=style&index=0&id=187bbbb2&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__